import { useEffect } from 'react';
import { FieldErrors } from 'react-hook-form';

export default function useScrollToError(errors: FieldErrors) {
	useEffect(() => {
		const errorValues = Object.values(errors);
		if (errorValues.length > 0) {
			let firstErrorElement = document.getElementsByName(
				errorValues[0]?.ref?.name,
			)[0];

			if (
				firstErrorElement &&
				firstErrorElement.getAttribute('type') === 'hidden' &&
				firstErrorElement.parentElement !== null
			) {
				firstErrorElement = firstErrorElement.parentElement;
			}

			// This part is a failsafe for when the name on the controller does not match the name on the input
			if (!firstErrorElement) {
				for (const p of document.querySelectorAll('p')) {
					if (p.textContent?.includes(errorValues[0].message)) {
						firstErrorElement = p;
						break;
					}
				}
			}

			if (firstErrorElement) {
				firstErrorElement.scrollIntoView({
					behavior: `smooth`,
					block: 'center',
				});
			}
		}
	}, [errors]);
}
